<script lang="ts" setup>
import { HeaderWrapper } from '@haskoning/vue-component-library'
import { storeToRefs } from 'pinia'
import { useCalculationStore } from '@/stores/calculation'
import { useCalculationCPTStore } from '@/stores/calculationCPT'
import { useProjectParameterStore } from '@/stores/projectParameter'
import { useCalculationParameterStore } from '@/stores/calculationParameter'
import { useGiDataUploadCollectionStore } from '@/stores/giDataUploadCollection'
import { useProjectUserStore } from '@/stores/projectUser'
import { useAuthenticationStore } from '@/stores/authentication'
import { useProjectStore } from '@/stores/project'
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'
import Breadcrumbs from '@/components/app/Breadcrumbs.vue'
import { INDEX_ROUTES } from '@/router'

const authStore = useAuthenticationStore()
const router = useRouter()
const route = useRoute()

const projectStore = useProjectStore()

const { writeLoading: projectWriteLoading } = storeToRefs(useProjectStore())
const { writeLoading: projectParWriteLoading } = storeToRefs(useProjectParameterStore())
const { writeLoading: calculationWriteLoading } = storeToRefs(useCalculationStore())
const { writeLoading: cptWriteLoading } = storeToRefs(useCalculationCPTStore())
const { writeLoading: calculationParLoading } = storeToRefs(useCalculationParameterStore())
const { writeLoading: collectionLoading } = storeToRefs(useGiDataUploadCollectionStore())
const { writeLoading: projectUserLoading } = storeToRefs(useProjectUserStore())

const { user } = storeToRefs(authStore)

const loading = computed(() => {
	return (
		projectWriteLoading.value ||
		projectParWriteLoading.value ||
		calculationWriteLoading.value ||
		cptWriteLoading.value ||
		calculationParLoading.value ||
		collectionLoading.value ||
		projectUserLoading.value
	)
})

const currentRouteName = computed(() => route.name)

const isToggleButtonShown = computed(() => {
	return currentRouteName.value == 'project-detail'
})

async function logout() {
	await authStore.logout()
	await authStore.$patch({
		user: null
	})
	await router.push({ name: 'auth-login' })
}

const goToProjectIndex = () => {
	router.push({ name: INDEX_ROUTES.PROJECT.INDEX.name })
}
</script>

<template>
	<HeaderWrapper
		v-if="user"
		title="Liquefaction"
		:user="user"
		:loading="loading"
		@logo-click="goToProjectIndex"
		@logout="logout()"
	>
		<template v-if="isToggleButtonShown" v-slot:toolbar-prepend>
			<v-app-bar-nav-icon
				class="pl-4 mx-1 no-overlay"
				height="36"
				width="36"
				color="white"
				:ripple="false"
				:icon="projectStore.drawer.shown ? 'mdi-close' : 'mdi-menu'"
				@click="projectStore.toggleDrawer"
			/>
		</template>

		<template v-slot:breadcrumbs-items>
			<Breadcrumbs />
		</template>
	</HeaderWrapper>
</template>
